import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['container', 'innerContainer', 'control', 'label'];
var controlStyles = {
  borderColor: 'grey.800',
  backgroundPosition: 'center',
  _checked: {
    borderWidth: '0.0625rem',
    borderColor: 'grey.800',
    _before: {
      content: "\"\"",
      display: 'inline-block',
      pos: 'relative',
      w: '78%',
      h: '78%',
      borderRadius: '50%',
      bg: 'blue.600'
    }
  },
  _focus: {
    boxShadow: '0 0 0 0.1875rem rgba(255, 213, 48, 1)'
  },
  _invalid: {
    borderColor: 'red.700',
    borderWidth: '2px',
    _focus: {
      boxShadow: '0 0 0 0.1875rem rgba(255, 213, 48, 1)'
    }
  },
  _disabled: {
    borderColor: 'grey.700',
    bg: 'grey.200',
    opacity: 0.6
  }
};
var labelStyles = {
  _disabled: {
    color: 'grey.700'
  }
};
var containerStyles = {
  color: 'grey.980'
};
var innerContainerStyles = {
  padding: '1rem 1.25rem',
  bg: 'grey.270',
  transition: 'background 150ms ease',
  _hover: {
    bg: '#B5B5B5'
  },
  _disabled: {
    bg: 'grey.300',
    cursor: 'auto'
  }
};
var baseStyle = () => ({
  container: containerStyles,
  label: labelStyles,
  control: controlStyles,
  innerContainer: innerContainerStyles
});
var sizes = {
  sm: {
    innerContainer: {
      padding: '.6rem .8rem'
    },
    control: {
      _checked: {
        borderWidth: '1px'
      }
    }
  },
  lg: {
    innerContainer: {
      padding: '1.25rem 1.5rem'
    }
  }
};
var defaultProps = {
  size: 'md'
};
export var Radio = asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  defaultProps
});